import axios from 'axios'

export const downloadS3URL = async (url: string) => {
  const response = await axios.get(url)
  return response
}
